<template>
    <div class="game-container">
        <div v-if="!roomId" class="room-selection">
            <h2>植物大战僵尸 - 多人对战</h2>
            <div class="room-list" >
                <h3>可用房间：</h3>
                <div class="room-items">
                    <div v-for="room in rooms" :key="room.id" class="room-item">
                        <span>房间号: {{ room.id }}</span>
                        <span>玩家数: {{ room.playerCount }}/2</span>
                        <button
                            @click="joinRoom1(room.id)"
                            :disabled="room.playerCount >= 2 || room.status !== 'waiting'"
                        >
                            加入
                        </button>
                    </div>
                </div>
            </div>
            <div class="room-buttons">
                <button class="create-btn" @click="createRoom">创建房间</button>
                <div class="join-room">
                    <input v-model="joinRoomId" placeholder="输入房间号" />
                    <button class="join-btn" @click="joinRoom2">加入房间</button>
                </div>
            </div>
        </div>
        <div v-else class="game-content">
            <div class="game-header">
                <div class="room-info">
                    <span>房间号: {{ roomId }}</span>
                    <span v-if="gameStarted" class="timer"
                        >时间: {{ formatTime(timeRemaining) }}</span
                    >
                </div>
                <div class="player-info">
                    <span>玩家: {{ username }}</span>
                    <span>阳光: {{ sunAmount }}</span>
                    <span>得分: {{ score }}</span>
                    <span v-if="playerRole"
                        >角色: {{ playerRole === 'plants' ? '植物方' : '僵尸方' }}</span
                    >
                </div>
                <button @click="handleLogout" class="logout-btn">退出游戏</button>
            </div>
            <div id="game-canvas"></div>
            <div v-if="!gameStarted && roomId" class="waiting-screen">
                <h3>等待玩家加入...</h3>
                <p>将房间号分享给好友：{{ roomId }}</p>
            </div>
        </div>
        <div v-if="showRoleSelectionDialog" class="role-selection">
            <h3>选择你的角色</h3>
            <div class="role-buttons">
                <button @click="selectRole('plants')" class="role-btn plants-btn">植物方</button>
                <button @click="selectRole('zombies')" class="role-btn zombies-btn">僵尸方</button>
            </div>
        </div>
    </div>
</template>

<script>
import Phaser from 'phaser';
import GameScene from '@/game/scenes/GameScene';
import io from 'socket.io-client';

export default {
    name: 'GameView',
    data() {
        return {
            game: null,
            socket: null,
            username: localStorage.getItem('username') || '玩家',
            score: 0,
            roomId: null,
            joinRoomId: '',
            playerRole: null,
            gameStarted: false,
            timeRemaining: 300, // 5分钟游戏时间
            timer: null,
            sunAmount: 100, // 添加阳光数量初始值
            rooms: [], // 新增：房间列表
            players: [], // 新增：当前房间的玩家列表
            showRoleSelectionDialog: false, // 新增：控制角色选择对话框的显示
        };
    },
    // watch: {
    //     showRoleSelectionDialog: {
    //         handler(newVal, oldVal) {
    //             this.showRoleSelectionDialog = true;
    //         },
    //         immediate: true,
    //     },
    // },
    methods: {
        createRoom() {
            this.socket.emit('createRoom', { username: this.username });
        },

        // 修改 joinRoom 方法
        joinRoom2() {
            if (this.joinRoomId) {
                this.socket.emit('joinRoom', {
                    roomId: this.joinRoomId.toUpperCase(),
                    username: this.username,
                });
            } else {
                this.showMessage('请输入房间号');
            }
        },
        joinRoom1(btnroomId) {
            if (btnroomId) {
                this.socket.emit('joinRoom', {
                    roomId: btnroomId.toUpperCase(),
                    username: this.username,
                });
            } else {
                this.showMessage('请输入房间号');
            }
        },

        initSocket() {
            this.socket = io('http://localhost:3000');   //IPV4
            // this.socket = io('http://[2a02:ab88:760c:7080:e55a:89c2:37ff:9e0d]:3000');  //IPV6
            // 房间创建相关
            this.socket.on('roomCreated', (data) => {
                this.roomId = data.roomId;
                this.showMessage(`房间创建成功！房间号：${data.roomId}`);
            });
            // 加入房间成功
            this.socket.on('joinedRoom', (data) => {
                this.roomId = data.roomId;
                this.showMessage('成功加入房间！');
            });
            // 房间列表更新
            this.socket.on('roomsUpdated', (rooms) => {
                this.rooms = rooms; // 添加 rooms 到 data 中
            });

            // 加入房间相关
            this.socket.on('error', (data) => {
                this.showMessage(data.message);
            });

            this.socket.on('playerJoined', (data) => {
                this.players = data.players;
                this.showMessage('新玩家加入了房间！');
            });

            this.socket.on('roomReady', () => {
                this.showMessage('房间人数已满，请选择角色！');
                this.showRoleSelectionDialog = true; // 显示角色选择对话框
            });

            // 玩家状态更新
            this.socket.on('playerStatusUpdate', (data) => {
                this.players = data.players;
                // 更新显示其他玩家的选择
                const otherPlayer = data.players.find((p) => p.username !== this.username);
                if (otherPlayer && otherPlayer.role) {
                    this.showMessage(
                        `对方选择了${otherPlayer.role === 'plants' ? '植物方' : '僵尸方'}`
                    );
                }
            });

            this.socket.on('roleSelected', (data) => {
                if (data.success) {
                    this.playerRole = data.role;
                    this.showMessage(`你选择了${data.role === 'plants' ? '植物方' : '僵尸方'}`);
                    this.showRoleSelectionDialog = false;
                } else {
                    this.showMessage(data.message);
                    this.showRoleSelectionDialog = true; // 重新显示角色选择
                }
            });
            // 添加阳光数量更新监听
            this.socket.on('sunAmountUpdate', (data) => {
                if (data.playerId === this.socket.id) {
                    this.sunAmount = data.amount;
                }
            });

            // 游戏状态更新时也更新阳光数量
            this.socket.on('gameStateUpdate', (gameState) => {
                if (gameState.sunAmount) {
                    const role = this.playerRole;
                    if (role) {
                        this.sunAmount = gameState.sunAmount[role];
                    }
                }
            });
            // 游戏开始相关
            this.socket.on('gameStart', () => {
                this.gameStarted = true;
                this.showRoleSelectionDialog = false;
                this.initGame();
                this.startGameTimer();
                this.showMessage('游戏开始！');
                this.socket.emit('requestSun');
            });

            // 时间更新
            this.socket.on('timeUpdate', (data) => {
                this.timeRemaining = data.timeRemaining;
            });

            // 游戏结束
            this.socket.on('gameOver', (data) => {
                this.handleGameOver(data);
            });

            // 玩家离开
            this.socket.on('playerLeft', (data) => {
                this.players = data.players;
                this.showMessage('有玩家离开了游戏');
            });

            // 获取初始房间列表
            this.socket.emit('getRooms');
        },

        initGame() {
            const config = {
                type: Phaser.AUTO,
                parent: 'game-canvas',
                width: 800,
                height: 600,
                // backgroundColor: '#a5d6a7',
                physics: {
                    default: 'arcade',
                    arcade: {
                        gravity: { y: 1 },
                        debug: false,
                    },
                },
                scene: GameScene,
                scale: {
                    mode: Phaser.Scale.FIT,
                    autoCenter: Phaser.Scale.CENTER_BOTH,
                },
            };

            this.game = new Phaser.Game(config);
            this.game.scene.start('GameScene', {
                socket: this.socket,
                username: this.username,
                role: this.playerRole,
            });
        },

        // 修改显示角色选择对话框的方法
        showRoleSelection() {
            this.showRoleSelectionDialog = true;
        },

        // 修改选择角色的方法
        selectRole(role) {
            console.log('123', role);
            if (this.roomId) {
                this.socket.emit('selectRole', { role });
            }
        },

        startGameTimer() {
            this.timer = setInterval(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--;
                } else {
                    this.socket.emit('timeUp');
                    clearInterval(this.timer);
                }
            }, 1000);
        },

        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
        },

        showMessage(message) {
            // 这里可以改用更好的UI组件来显示消息
            alert(message);
        },

        handleGameOver(data) {
            clearInterval(this.timer);
            this.gameStarted = false;
            this.roomId = null;
            this.playerRole = null;
            this.timeRemaining = 300;

            if (data) {
                const message = data.winner
                    ? `游戏结束！${data.winner}获胜！\n植物方得分：${data.plantsScore}\n僵尸方得分：${data.zombiesScore}`
                    : '游戏结束！';
                this.showMessage(message);
            }

            if (this.game) {
                this.game.destroy(true);
                this.game = null;
            }
        },

        handleLogout() {
            if (confirm('确定要退出游戏吗？')) {
                this.socket.disconnect();
                this.$router.push('/login');
            }
        },
    },
    mounted() {
        this.initSocket();
    },
    beforeUnmount() {
        if (this.socket) {
            this.socket.disconnect();
        }
        if (this.game) {
            this.game.destroy(true);
        }
        clearInterval(this.timer);
    },
};
</script>

<style lang="scss" scoped>
.game-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    overflow: hidden; // 防止溢出
}

.room-selection {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    h2 {
        color: #2c3e50;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    }

    .room-buttons {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 300px;
    }

    button {
        padding: 0.8rem 1.5rem;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1rem;
        transition: all 0.3s ease;

        &.create-btn {
            background-color: #4caf50;
            color: white;

            &:hover {
                background-color: #45a049;
            }
        }

        &.join-btn {
            background-color: #2196f3;
            color: white;

            &:hover {
                background-color: #1e88e5;
            }
        }
    }

    .join-room {
        display: flex;
        gap: 0.5rem;

        input {
            flex: 1;
            padding: 0.8rem;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 1rem;

            &:focus {
                outline: none;
                border-color: #2196f3;
            }
        }
    }
}

.game-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative; // 添加相对定位
}

.game-header {
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(76, 175, 80, 0.9);
    color: white;
    z-index: 10; // 确保在画布上方

    .room-info {
        min-width: 200px;
        display: flex;
        gap: 1rem;

        .timer {
            margin-left: 1rem;
        }
    }

    .player-info {
        display: flex;
        gap: 2rem;
        flex-wrap: nowrap;
        white-space: nowrap;
    }
}

.logout-btn {
    padding: 0.5rem 1rem;
    background-color: #f44336;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #d32f2f;
    }
}

#game-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    canvas {
        width: 100%;
        height: 100%;
    }
}

.waiting-screen {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    h3 {
        color: #2c3e50;
        margin-bottom: 1rem;
    }

    p {
        color: #666;
    }
}
.room-list {
    margin-bottom: 2rem;
    width: 100%;
    max-width: 500px;

    .room-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        margin: 0.5rem 0;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        button {
            padding: 0.5rem 1rem;
            background-color: #2196f3;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;

            &:disabled {
                background-color: #ccc;
                cursor: not-allowed;
            }
        }
    }
}

.role-selection {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000; // 确保在最上层
    button {
        margin: 1rem;
        padding: 0.8rem 1.5rem;
        font-size: 1rem;
    }
}
.room-items {
    overflow: scroll;
    width: 500px;
    height: 140px;
}
</style>
